module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/bonus-pict-72f0bc9e2d0507bb6c91075dcab421b3.jpg";